import loadingMutations from '@motionelements/core/src/store/mutations-mixins/loadingMutation.js';
import programsApi from '@/api/artist/programs.js';

const state = {
  addOns: [],
  isLoaded: false,
  loading: false,
};

const actions = {
  LIST_ADD_ONS({ commit }, params) {
    commit('setLoading', true);
    return programsApi.listPrograms(params)
      .then(({ data: { data: programs } }) => {
        const addOns = programs.filter(({ type }) => type !== 'gcp');
        commit('setAddOns', addOns);
        commit('setIsLoaded', true);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setAddOns(state, addOns) {
    state.addOns = addOns;
  },
  updateAddOn(state, addOn) {
    const index = state.addOns.findIndex(({ code }) => addOn.code === code);
    const updatedAddOn = { ...state.addOns[index], ...addOn };
    if (index > -1) state.addOns.splice(index, 1, updatedAddOn);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations: {
    ...mutations,
    ...loadingMutations,
  },
};
